"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Level", {
  enumerable: true,
  get: function () {
    return _Level.Level;
  }
});
exports.write = exports.setUser = exports.setFilter = exports.setApplication = exports.flush = exports.configureMetrics = exports.clearUser = exports.default = void 0;

var _Level = require("@adobe/exc-app/metrics/Level");

var _RecordType = require("@adobe/exc-app/metrics/RecordType");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let readyResolve;
const readyPromise = new Promise(resolve => {
  readyResolve = resolve;
});
let runtimePromise;
let ready = false;
let queue = [];
let toFlush = false;
let filter;
let uuidv1;

const writeWithVersion = async record => {
  const {
    sdkVersion
  } = adobeMetrics;
  record.metricsState = Object.assign(record.metricsState || {}, {
    sdkVersion
  });

  if (record.metricsState.correlationId === 'uuid') {
    record.metricsState.correlationId = uuidv1();
  }

  return adobeMetrics.write(record);
};

const onConfigure = () => {
  if (!ready) {
    readyResolve();
    queue.forEach(writeWithVersion);
    queue = [];
    toFlush && adobeMetrics.flush();
    ready = true;
  }
};

const write = async record => {
  filter && (record = await filter(record));

  if (ready) {
    return writeWithVersion(record);
  }

  queue.push(record);
  return 0;
};

exports.write = write;
const w = window;

if (!w.adobeMetrics) {
  w.adobeMetrics = {
    write
  };
}

const flush = async () => {
  if (ready) {
    return adobeMetrics.flush();
  }

  toFlush = true;
  return 0;
};

exports.flush = flush;

async function executOnReady(action) {
  ready || (await readyPromise);
  action();
}

const clearUser = version => executOnReady(() => adobeMetrics.clearUser(version));

exports.clearUser = clearUser;

const setUser = (user, version) => executOnReady(() => adobeMetrics.setUser(user, version));

exports.setUser = setUser;

const setApplication = app => executOnReady(() => adobeMetrics.setApplication(app));

exports.setApplication = setApplication;

const setFilter = filterFunction => {
  filter = filterFunction;
};

exports.setFilter = setFilter;

const configureMetrics = config => {
  runtimePromise || (runtimePromise = Promise.resolve().then(() => _interopRequireWildcard(require('./metricsRuntime'))));
  return runtimePromise.then(({
    MetricsRuntime,
    uuidv1: uuidv1Func
  }) => {
    uuidv1 = uuidv1Func;

    if (adobeMetrics.write === write) {
      delete adobeMetrics.write;
    }

    return MetricsRuntime.configure(config);
  }).then(returnedConfig => {
    config && onConfigure();
    return returnedConfig;
  });
};

exports.configureMetrics = configureMetrics;

const now = () => performance.now();

class MetricsTimer {
  constructor(name, context, prefix, ...args) {
    this.epoch = now();
    this.now = now();
    this.context = context;
    this.name = name;
    this.prefix = prefix;
    this.now = now();
    this.time('start', ...args);
  }

  time(eventName, ...args) {
    let event; // calculate new event

    if (eventName && typeof eventName === 'object') {
      event = eventName.event;
    } else {
      event = (this.prefix || '') + (this.prefix && eventName ? '.' : '') + (eventName || '');
    }

    const _now = now();

    const duration = _now - this.epoch;
    const record = {
      data: args.length > 0 ? [...args] : undefined,
      dateNow: Date.now(),
      duration,
      epoch: this.epoch,
      event,
      level: _Level.Level.INFO,
      metricsState: {
        context: this.context,
        correlationId: 'uuid'
      },
      name: this.name,
      now: _now,
      prefix: this.prefix,
      recordType: _RecordType.RecordType.TIMER
    };
    write(record);
    return duration;
  }

}

class LazyMetrics {
  constructor(name, ...args) {
    /**
     * The history object emulates window history APIs for recording history
     * metrics. When using push or replace you can specify the path and state
     * as separate arguments, or specify path as a string and state as an
     * object, or put everything into one location-like argument. In all cases,
     * the resulting history record will be a location-like argument of the
     * form {path, search, hash, state}.
     *
     * If path is supplied as a string it will be disassembled into a
     * location-like object and the state parameter will be added to that
     * object if the supplied state parameter was an object.
     *
     * The resulting location-like object will be stored in the data property of
     * the metric if the prop props argument is empty. If props is not empty,
     * then the constructed location-like object will be the first object in an
     * array on the metric data property, and the remainder of the array will
     * come from processing the props parameter through makeDataBag().
     */
    this.history = {
      back: (...args) => this._historyLog('back', args),
      forward: (...args) => this._historyLog('forward', args),
      go: (n, ...args) => {
        args.unshift({
          n
        });
        return this._historyLog('go', args);
      },
      push: (path, state, ...args) => {
        args.unshift({
          path,
          state
        });
        return this._historyLog('push', args);
      },
      replace: (path, state, ...args) => {
        args.unshift({
          path,
          state
        });
        return this._historyLog('replace', args);
      }
    };
    /**
     * Adobe Analytics for Adobe - aka OMEGA. These APIs emulate
     * window._satellite.track() methods.
     *
     * Applications which self-manage the analytics javascript and handle
     * updating the window.digitalData object should call metrics.analytics.track()
     * immediately adjacent to calling window._satellite.track(), either before or
     * after.
     *
     * Applications which provide the analytics javascript url to Metrics Runtime
     * configuration can can call trackEvent(), trackPage() or trackUser() and
     * supply the corresponding data object as an argument. In this case, Metrics
     * will update the window digitalData object and take care of invoking
     * window._satellite.track as well as Metrics' track().
     */

    this.analytics = {
      track: (type, ...args) => this._trackLog(type, args),
      trackEvent: (eventData, ...args) => {
        args.unshift(eventData);
        return this._trackLog('Event', args);
      },
      trackPage: (pageData, ...args) => {
        args.unshift(pageData);
        return this._trackLog('Page', args);
      },
      trackUser: (userData, ...args) => {
        args.unshift(userData);
        return this._trackLog('User', args);
      }
    };
    /**
     * Location methods emit Location recordTypes and also triggers tracking of
     * a new page load. A new historyId will be generated, page state will
     * transition to active. Location methods should be await'ed just prior to the
     * corresponding window.location method to allow flush of any remaining
     * metrics from the current window to remote storage before the window
     * contents change.
     */

    this.location = {
      /**
       * Record a location assign event.
       * @param {string} url A string for the window location path being assigned.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */
      assign: (url, ...props) => {
        props.unshift({
          url
        });
        return this._log(_RecordType.RecordType.LOCATION, _Level.Level.INFO, this.name, undefined, 'assign', undefined, props);
      },

      /**
       * Record a location reload event.
       * @param {boolean} force A boolean to indicate that the page was or will be
       * reloaded from the server.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */
      reload: (force, ...props) => {
        props.unshift({
          force
        });
        return this._log(_RecordType.RecordType.LOCATION, _Level.Level.INFO, this.name, undefined, 'reload', undefined, props);
      },

      /**
       * Record a location replace event.
       * @param {string} url A string for the window location path being assigned.
       * @param {any} props Any other properties will be assigned to the metric
       * according to makeDataBag();.
       * @returns {Promise} A promise that resolves to the number of metrics that
       * were flushed to remote storage.
       */
      replace: (url, ...props) => {
        props.unshift({
          url
        });
        return this._log(_RecordType.RecordType.LOCATION, _Level.Level.INFO, this.name, undefined, 'replace', undefined, props);
      }
    };
    this.name = name;
    args.length && (this.context = args[0]);
  }

  start(prefix, ...args) {
    return new MetricsTimer(this.name, this.context, prefix, ...args);
  }

  _log(recordType, level, name, message, event, dateNow, args) {
    dateNow = dateNow || Date.now();
    return write({
      data: args.length > 0 ? [...args] : undefined,
      dateNow,
      event,
      level,
      message,
      name,
      recordType
    });
  }

  _historyLog(event, args) {
    return this._log(_RecordType.RecordType.HISTORY, _Level.Level.INFO, this.name, undefined, event, undefined, args);
  }

  _trackLog(type, args) {
    return this._log(_RecordType.RecordType.ANALYTICS, _Level.Level.INFO, this.name, undefined, type, undefined, args);
  }
  /**
   * Queue a record for transmission to remote storage.
   * @param {Record} record - The object to be stored.
   */


  store(record) {
    record.name = this.name;
    write(record);
  }
  /**
   * Log an ERROR message to remote storage, with an optional
   * data payload; emulates console.error().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  error(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.ERROR, this.name, message, undefined, undefined, args);
  }
  /**
   * Log a WARN message to remote storage, with an optional data payload;
   * emulates console.warn().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  warn(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.WARN, this.name, message, undefined, undefined, args);
  }
  /**
   * Log an INFO message to remote storage, with an optional data payload;
   * emulates console.log().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  info(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.INFO, this.name, message, undefined, undefined, args);
  }
  /**
   * Log an INFO message to remote storage, with an optional data payload;
   * emulates console.info().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  log(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.INFO, this.name, message, undefined, undefined, args);
  }
  /**
   * Log a DEBUG message to remote storage, with an optional data payload;
   * emulates console.debug().
   * @function
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  debug(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.DEBUG, this.name, message, undefined, undefined, args);
  }
  /**
   * Log a TRACE message to remote storage, with an optional data payload;
   * emulates console.trace().
   * @param {string} message - The log message.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  trace(message, ...args) {
    return this._log(_RecordType.RecordType.LOG, _Level.Level.TRACE, this.name, message, undefined, undefined, args);
  }
  /**
   * Construct a named event and emit it to storage, along with an optional
   * data payload. Event level will default to INFO. To specify a different
   * level, add an level object to the args parameters in the form
   * {level: Level.DEBUG}.
   * @function
   * @param {string} event The event.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  event(event, ...args) {
    return this._log(_RecordType.RecordType.EVENT, _Level.Level.INFO, this.name, undefined, event, undefined, args);
  }
  /**
   * Construct a named "Recent" event and emit it to storage. The payload is expected
   * to contain PII so downstream handling must a) keep the data bag intact, and
   * b) send the Recent record (with PII) only to Unified Recents. PII must be
   * removed before sending to ADX.
   * @function
   * @param {string} revent The event.
   * @param {any} args Optional arguments to be applied to the recorded metrics.
   * @returns {Promise} A promise that resolves to the number of metrics that
   * were queued for eventual flushing.
   */


  recent(revent, ...args) {
    return this._log(_RecordType.RecordType.RECENT, _Level.Level.INFO, this.name, undefined, revent, undefined, args);
  }

}

exports.default = LazyMetrics;